import {computed, inject, Inject, Injectable} from '@angular/core';
import {exhaustMap, tap} from 'rxjs';
import {AUTH_CONFIG} from 'src/app/config/auth.config';
import {JWT_CONFIG} from 'src/app/config/jwt.config';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {decodeJwt} from 'src/app/shared/functions/encode-decode.functions';
import {ApiService} from './api.service';
import {CookieService} from './cookie.service';
import {AuthResponse} from '../models/auth.model';
import {IJWTDecoded, JWTschema, JWTState} from '../models/jwt.model';
import {createEffect} from 'src/app/shared/functions/create-effect.functions';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { ApiSentrynelService } from './api-sentrynel.service';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  readonly token = this.jwtStore.selectKey('token');
  readonly decodedToken = this.jwtStore.selectKey('decodedToken');
  readonly refreshInterval = this.jwtStore.selectKey('refreshInterval');
  readonly isValidToken = computed(() => (this.decodedToken().exp > this.decodedToken().iat) && (this.decodedToken().exp > (Math.floor(Date.now() / 1000))));
  refresh = createEffect((_) => _.pipe(
    exhaustMap(() => {
      return this.apiService.post<any>("auth/token", {
        token: this.jwtStore.selectKey('refreshToken'),
        clientId: environment.keycloak.clientId
      }).pipe(
        tap((data) => {
          if(data.access_token){
            this.set(data.access_token);
            this.setRefreshToken(data.refresh_token)
            return data.access_token;
          }
        })
      )
    })
  ));
  private refreshTokenInterval = computed(() => (((this.decodedToken()?.exp - this.decodedToken().iat) * 1000) - (AUTH_CONFIG.refreshTokenSecondsAhead * 1000)))

  constructor(
    @Inject('jwt-store') private readonly jwtStore = inject(SignalStore<JWTState>),
    private cookieService: CookieService,
    private apiService: ApiService,
    private apiSentrynelService: ApiSentrynelService,
    private keycloakService:KeycloakService
  ) {
    if (this.cookieService.check(JWT_CONFIG.jwtCookieName)) {
      this.set(this.cookieService.get(JWT_CONFIG.jwtCookieName));
    }
    if (this.cookieService.check(JWT_CONFIG.refreshToken)) {
      this.setRefreshToken(this.cookieService.get(JWT_CONFIG.refreshToken));
    }
        if(this.cookieService.check(JWT_CONFIG.IdTokenHint)){
      this.setIdTokenHint(this.cookieService.get(JWT_CONFIG.IdTokenHint));
    }
  }

  public async set(jwtToken: string) {
    //const token = await this.keycloakService.getToken()
    //console.log(jwtToken)
    this.jwtStore.setKey<'token'>('token', jwtToken);
     var decodedToken = decodeJwt<IJWTDecoded>(jwtToken, JWTschema)
      this.jwtStore.setKey('decodedToken', decodedToken);
      if (this.isValidToken()) {
    
        //this.apiService.setHeader('Authorization', `Bearer ${jwtToken}`);
        //this.apiSentrynelService.setHeader('Authorization', `Bearer ${jwtToken}`);
    
        this.cookieService.set(JWT_CONFIG.jwtCookieName, jwtToken);

        clearInterval(this.refreshInterval());
        this.jwtStore.setKey('refreshInterval', setInterval(() => {
          this.refresh();
        }, this.refreshTokenInterval()));
      } else {
        this.unset();
      }
    
  }

  
  public getTokenJwt(){
    return this.jwtStore.selectKey("token")()
  }

  public async setRefreshToken(refreshToken: string){
    this.jwtStore.setKey<'refreshToken'>('refreshToken', refreshToken);
    this.cookieService.set(JWT_CONFIG.refreshToken, refreshToken);
  }
  async setIdTokenHint(IdTokenHint: string) {
    this.jwtStore.setKey<'IdTokenHint'>('IdTokenHint', IdTokenHint);
    this.cookieService.set(JWT_CONFIG.IdTokenHint, IdTokenHint);
  }

  public getRefreshToken(){
    return this.jwtStore.selectKey("refreshToken")()
  }
   getIdTokenHint(): string {
    return this.jwtStore.selectKey("IdTokenHint")();
  }

  public unset() {
    this.jwtStore.setKey('decodedToken', {
      iat: 0,
      exp: 0,
      userId: null
    });
    this.jwtStore.setKey<'token'>('token', '');
    this.jwtStore.setKey<'refreshToken'>('refreshToken', '');
    this.cookieService.delete(JWT_CONFIG.jwtCookieName);
    this.cookieService.delete(JWT_CONFIG.refreshToken);
        this.cookieService.delete(JWT_CONFIG.IdTokenHint);
    this.apiService.setHeader('Authorization', undefined);
    if (this.refreshInterval()) {
      clearInterval(this.refreshInterval());
    }
   // this.keycloakService.logout(environment.keycloak.redirectUrl)
  }

}
